<template>
  <q-dialog
    ref="dialog"
    @hide="onDialogHide"
  >
    <q-card
      flat
      bordered
      class="q-dialog-plugin"
    >
      <q-toolbar
        dense
        color="primary"
      >
        <q-avatar>
          <q-icon
            name="mdi-arrow-collapse"
            color="green"
            size="md"
            class="q-pa-none"
          />
        </q-avatar>

        <q-toolbar-title>
          <span class="text-weight-bold">Transferência</span> para {{ numberType }}
        </q-toolbar-title>

        <q-btn
          flat
          round
          dense
          icon="mdi-close"
          v-close-popup
        />
      </q-toolbar>

      <q-separator inset />

      <q-card-section>
        <i>{{ description }}</i>
        <br>
        <br>
        Deseja Transferir uma chamada que está andamento para o número de entrada <b>{{ number }}</b>?
      </q-card-section>

      <q-separator />

      <q-card-section>
        <q-list
          dense
          class="rounded-borders full-width q-px-sm"
        >
          <template v-for="ongoingCall in ongoingCalls">
            <q-item
              v-ripple
              clickable
              :key="`item-${ongoingCall.id}`"
              @click="onOKClick('TRANSFER', ongoingCall.id)"
            >
              <q-item-section>
                <div class="row items-center">
                  <div class="col">
                    <q-item-label>
                      {{ ongoingCall.contact }}
                    </q-item-label>
                  </div>

                  <div class="col-auto">
                    <q-icon
                      name="mdi-arrow-collapse"
                      color="green"
                      size="md"
                      class="q-pa-none"
                    />
                  </div>
                </div>

                <q-tooltip>
                  Transferir para {{ ongoingCall.contact }}
                </q-tooltip>
              </q-item-section>
            </q-item>

            <q-separator
              v-if="ongoingCalls.at(-1) !== ongoingCall"
              :key="`sep-${ongoingCall.id}`"
              class="q-my-sm"
            />
          </template>
        </q-list>
      </q-card-section>

      <q-separator />

      <q-card-actions align="around">
        <q-btn
          flat
          no-caps
          padding="5px 12px"
          color="red-8"
          @click="onOKClick('CALL')"
        >
          Discar para {{ number }}
        </q-btn>

        <q-btn
          no-caps
          padding="5px 12px"
          color="primary"
          @click="onCancelClick"
        >
          Transferir para {{ number }}
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { VOICE_CHANNEL } from '@/constants/channels'
import { entryNumberType } from '@/libs/transferUtils'

export default {
  props: {
    entryNumber: {}
  },

  computed: {
    ...mapState({
      ongoingCalls: ({ attendanceModule }) => {
        const calls = Object.values(attendanceModule.current)
        return calls.filter(({ channel }) => channel === VOICE_CHANNEL)
      }
    }),

    number () {
      const { number } = this.entryNumber ?? {}
      return number ?? ''
    },

    description () {
      const { description } = this.entryNumber ?? {}
      return description ?? ''
    },

    numberType () {
      return entryNumberType(this.entryNumber)
    }
  },

  methods: {
    show () {
      this.$refs.dialog.show()
    },

    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      this.$emit('hide')
    },

    onOKClick (action, sessionId) {
      this.$emit('ok', { action, sessionId })
      this.hide()
    },

    onCancelClick () {
      this.hide()
    }
  },

  watch: {
    ongoingCalls (ongoingCalls) {
      if (!ongoingCalls.length) this.onCancelClick()
    }
  }
}
</script>
